import React, { useContext } from 'react'
import { Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import { Context } from '../ChargeSummary'

const _Table = () => {

  const { state } = useContext(Context);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Hình thức</th>
              <th scope="col">Số lần nạp</th>
              <th scope="col">Tổng tiền</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow from={state.filter.from} to={state.filter.to} phone={state.filter.phone} rIndex={index} key={`table-keys-lottmekong-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
      </Card>
    </>
  );
};

export default React.memo(_Table)